@use '@/styles/tokens' as *;

.drawerBody {
  padding: 0 !important;
}

.center {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: var(--space-6);
}

.body {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.header {
  position: relative;
  padding: 20px 34px;
  color: #fff;
  background: $color-green-secondary-900;
}

.headerMain {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
}

.headerLeft {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.title {
  margin: 0;
  font-family: #{$font-family-heading};
  font-size: 20px;
  font-weight: var(--font-weight-regular);
  letter-spacing: -0.4px;
  color: #fff;
}

.agent {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  font-size: 13px;
}

.role {
  opacity: 0.75;
}

.headerRight {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
}

.ref {
  font-size: 11px;
  opacity: 0.9;
}

.close {
  position: absolute;
  top: 13px;
  right: 11px;
}

.thread {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  padding: var(--space-5) var(--space-6);
  overflow-y: auto;
  background: var(--surface, #fff);
}

.dayGroup {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.daySeparator {
  display: flex;
  justify-content: center;
  font-size: 14px;
  color: var(--text-muted);
}

.bubbleRow {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-2);
  max-width: 64%;
}

.bubbleMine {
  align-self: flex-end;
  align-items: flex-end;
}

.bubble {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px 24px;
  border-radius: 22px;
}

/* Support (incoming): subtle surface, pointed top-right + sharp bottom-left. */
.bubbleReceived {
  background: var(--surface-subtle);
  border-radius: 22px 2px 22px 0;
}

/* Grower (outgoing): lime accent, pointed top-left + sharp bottom-right. */
.bubbleSent {
  padding: 19px 24px;
  background: $color-accent1-300;
  border-radius: 2px 22px 0 22px;
}

.bubbleText {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #1a1c1a;
  white-space: pre-wrap;
}

.thumbs {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.thumb {
  position: relative;
  width: 93px;
  height: 72px;
  overflow: hidden;
  border-radius: 8px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  /* Subtle darkening overlay (Figma rgba(0,0,0,0.1)). */
  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.1);
  }
}

.time {
  font-size: 12px;
  color: var(--text-disabled);
}

.composer {
  display: flex;
  align-items: flex-end;
  gap: var(--space-3);
  padding: var(--space-4) var(--space-5);
  border-top: 1px solid $color-neutral-200;

  :global(.ant-input) {
    border-radius: 999px;
  }
}

.send {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  color: #fff;
  background: $color-brand-950;
  border: none;
  border-radius: 50%;
  cursor: pointer;

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
}
